module.exports = __webpack_public_path__ + "img/arabe.3c7b9519.svg";